import { render, staticRenderFns } from "./system-loading.vue?vue&type=template&id=2fa6d350&"
import script from "./system-loading.vue?vue&type=script&lang=ts&"
export * from "./system-loading.vue?vue&type=script&lang=ts&"
import style0 from "./system-loading.vue?vue&type=style&index=0&id=2fa6d350&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports